<template>
  <div>
    <h2 class="title is-4">{{ $t("custom fields") }}</h2>

    <div v-if="meta && meta.length">
      <div class="field" v-for="(custom_field, cidx) in meta" :key="cidx">
        <div class="control" v-if="custom_field.type == 'text'">
          <label class="label">{{ custom_field.name }}</label>
          <input class="input" type="text" v-model="custom_field.value" />
        </div>
        <div class="control" v-else-if="custom_field.type == 'date'">
          <label class="label">{{ custom_field.name }}</label>
          <input class="input" type="date" v-model="custom_field.value" />
        </div>
        <div class="control" v-else-if="custom_field.type == 'number'">
          <label class="label">{{ custom_field.name }}</label>
          <input class="input" type="number" v-model="custom_field.value" />
        </div>
        <div class="control" v-else-if="custom_field.type == 'boolean'">
          <input
            class="is-checkradio"
            type="checkbox"
            :id="'chk_field' + cidx"
            :name="'chk_field' + cidx"
            v-model="custom_field.value"
          />
          <label :for="'chk_field' + cidx">{{ custom_field.name }}</label>
        </div>
        <div class="control" v-else-if="custom_field.type == 'dropdown'">
          <label class="label">{{ custom_field.name }}</label>
          <div class="select">
            <select v-model="custom_field.value">
              <option value="">{{ $t("select one") }}</option>
              <option
                v-for="(option, oidx) in custom_field.options.split(',')"
                :key="oidx"
                :value="option"
              >
                {{ option }}
              </option>
            </select>
          </div>
        </div>
        <div class="control" v-else>
          <label class="label">{{ custom_field.name }}</label
          >not implemented yet
        </div>
      </div>
      <!-- <pre>{{ module_settings.custom_fields }}</pre> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      meta: {},
    };
  },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  methods: {
    set_data(data) {
      let v = this;
      data.map((d) => {
        let trgt = v.meta.find((m) => m.name == d.name);
        if (trgt) trgt.value = d.value;
      });
    },
    set_initial_state() {
      let v = this;
      if (v.module_settings && v.module_settings.custom_fields)
        v.meta = JSON.parse(JSON.stringify(v.module_settings.custom_fields));
    },
    get_data() {
      return this.meta;
    },
  },
};
</script>

<style scoped>
.field {
  margin-bottom: 10px;
}
</style>
